import styled from "styled-components";

export const FilterInput = styled.input`
  height: 56px;
  width: 500px;
  border: 1px solid #5071f4;
  padding: 1em;
  margin: 1em auto;
  display: flex;
  position: relative;
`;